import { OnEscapeListener } from '@carvana/merch-components';
import dynamic from 'next/dynamic';
import React, { useContext } from 'react';
import FocusLock from 'react-focus-lock';
import ModalContext from '~/context/vdp/ModalContext';
import { BackgroundWrapper, Wrapper } from './AlertModal.styles';

const Portal = dynamic(
  () => import(/* webpackChunkName: "Portal" */ '@/common/Portal'),
  { ssr: false }
);

type OwnProps = React.PropsWithChildren<{
  fixed?: boolean;
  maxWidth?: string;
  onClose: () => void;
}>;

function AlertModal({
  children,
  fixed = false,
  maxWidth = '506px',
  onClose
}: OwnProps) {
  const { isAnyModalOpen } = useContext(ModalContext);

  return (
    <FocusLock autoFocus={false} disabled={isAnyModalOpen} group="alert-modal">
      <OnEscapeListener onEscape={onClose}>
        <BackgroundWrapper fixed={fixed}>
          <Wrapper maxWidth={maxWidth} data-qa="alert-modal">
            {children}
          </Wrapper>
        </BackgroundWrapper>
      </OnEscapeListener>
    </FocusLock>
  );
}

type WrapperProps = OwnProps & {
  fixed?: boolean;
  isOpen: boolean;
  target?: HTMLElement;
};

export default function AlertModalWrapper({
  children,
  isOpen,
  target,
  ...props
}: WrapperProps) {
  if (props.fixed) {
    return (
      <Portal open={isOpen} id="alert-modal" target={target}>
        <AlertModal {...props}>{children}</AlertModal>
      </Portal>
    );
  }

  return isOpen ? <AlertModal {...props}>{children}</AlertModal> : null;
}
